import { observable } from "mobx";
import ChargeChangeRejectionReason from "./chargeChangeRejectionReason";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class ChargePermittedActionResponse {
  @observable
  isAllowed!: boolean;

  @observable
  rejectionReason?: ChargeChangeRejectionReason;
}
